import "./Apps.css";

import React from "react";
import { Route } from "react-router-dom";
import classnames from "classnames";

import App from "../App/App";

function Apps(props) {
  const data = [
    {
      slug: "minecraft-categorizer",
      name: "Minecraft Categorizer",
      id: {
        web: "https://categorizer.ayy.fish",
      },
      description: "An app to help plan out your Minecraft storage system.",
      screenshots: [{ alt: "Home", src: "home" }],
    },
    {
      slug: "anime-reminder",
      name: "Anime Reminder",
      id: {
        ios: "1347756393",
        // android: "fish.ayy.animereminder",
      },
      email: "animereminder@ayy.fish",
      description:
        "An app to remind you when upcoming anime episodes air. Requires MyAnimeList or AniList account. Powered by MyAnimeList and AniList.",
      screenshots: [
        {
          alt: "Episodes",
          src: "episodes",
        },
        {
          alt: "Current Season",
          src: "current-season",
        },
        {
          alt: "Search",
          src: "search",
        },
      ],
    },
    {
      slug: "smash-clips",
      name: "Smash Clips",
      id: {
        ios: "1202665605",
        android: "fish.ayy.smashclips",
      },
      email: "smashclips@ayy.fish",
      description:
        "An app for watching the hottest Super Smash Bros. clips. Powered by Twitch.",
      screenshots: [
        {
          alt: "Main",
          src: "main",
        },
        {
          alt: "Features",
          src: "features",
        },
      ],
    },
    {
      slug: "anime-search",
      name: "Anime Search",
      id: {
        ios: "1193101926",
        android: "fish.ayy.animesearch",
      },
      email: "animesearch@ayy.fish",
      description:
        "An app to help find where to watch anime legally. Powered by BECAUSE.MOE.",
      screenshots: [
        {
          alt: "Home",
          src: "home",
        },
        {
          alt: "Search",
          src: "search",
        },
        {
          alt: "Details",
          src: "details",
        },
        {
          alt: "Providers settings",
          src: "providers-settings",
        },
        {
          alt: "Country settings",
          src: "country-settings",
        },
      ],
    },
    {
      slug: "halo-timers",
      name: "Halo Timers",
      id: {
        ios: "1141643575",
        android: "fish.ayy.halotimers",
      },
      email: "halotimers@ayy.fish",
      description: "An app to help track Halo 5 powerups and power weapons.",
      screenshots: [
        {
          alt: "Home",
          src: "home",
        },
        {
          alt: "Custom",
          src: "custom",
        },
        {
          alt: "Timers",
          src: "timers",
        },
      ],
    },
  ];

  const apps = data.map((app) => (
    <Route
      key={app.slug}
      path={"/" + app.slug}
      children={({ match }) => (
        <App {...app} match={match} changeSection={props.changeSection} />
      )}
    />
  ));

  return <div className={classnames("Apps", props.className)}>{apps}</div>;
}

export default Apps;



// WEBPACK FOOTER //
// ./src/components/Apps/Apps.js